<template>
  <div class="my-9 p-5">
    <div class="select-box">
      <DeviceSearchSelect placeholder="請選擇機台" @change="HandleChange" />
    </div>

    <div class="w-full mt-8 p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-6 dark:bg-gray-800 dark:border-gray-700">
      <h5 class="mb-3 text-base font-semibold text-gray-900 md:text-xl dark:text-white">系統啟動類</h5>
      <p class="text-sm font-normal text-gray-500 dark:text-gray-400">system</p>
      <ul class="my-4 space-y-3">
        <li
          class="flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
        >
          <span class="flex-1 ms-3 whitespace-nowrap">系統重新開機</span>
          <a-button @click="MqttSystemReboot()" :disabled="disabled" type="primary">
            <span class="text-wrapper">執行</span>
            <span class="icon-wrapper"> <a-icon type="right" /></span>
          </a-button>
        </li>
        <li
          class="flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
        >
          <span class="flex-1 ms-3 whitespace-nowrap">IPC 關機</span>
          <a-button @click="MqttIpcOff()" :disabled="disabled" type="primary">
            <span class="text-wrapper">執行</span>
            <span class="icon-wrapper"> <a-icon type="right" /></span>
          </a-button>
        </li>
        <li
          class="flex gap-3 items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
        >
          <span class="flex-1 ms-3 whitespace-nowrap">系統斷電重開</span>
          <a-date-picker show-time placeholder="開機時間" @change="PowerOnChange" />
          <a-date-picker show-time placeholder="關機時間" @change="PowerOffChange" />

          <a-button :disabled="disabled" type="primary">
            <span class="text-wrapper">執行</span>
            <span class="icon-wrapper"> <a-icon type="right" /></span>
          </a-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import DeviceSearchSelect from '@/components/DeviceSearchSelect.vue'
export default {
  name: 'HardwareControl',

  data () {
    return {
      loading: false,
      mac: null,
      disabled: true,
      powerOnTimestemp: null,
      powerOffTimestemp: null
    }
  },
  components: {
    DeviceSearchSelect
  },
  computed: {
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    }
  },
  mounted () {},
  methods: {
    PowerOnChange (value, dateString) {
    //   console.log('Selected Time: ', value)
      console.log('Formatted Selected Time: ', dateString)
      const dateObject = new Date(dateString)
      this.powerOnTimestemp = Math.floor(dateObject.getTime() / 1000)
    },
    PowerOffChange (value, dateString) {
    //   console.log('Selected Time: ', value)
      console.log('Formatted Selected Time: ', dateString)
      const dateObject = new Date(dateString)
      this.powerOffTimestemp = Math.floor(dateObject.getTime() / 1000)
    },
    HandleChange (mac) {
      this.mac = mac
      this.disabled = !this.mac
    },
    MqttSystemReboot () {
      const inf = JSON.stringify({
        delay: 5
      })
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = `command/${this.mac}/systemReboot`
      this.mqttClient.send(message)
    },
    MqttIpcOff () {
      const inf = JSON.stringify({
        delay: 5
      })
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = `command/${this.mac}/IpcOff`
      this.mqttClient.send(message)
    },
    MqttSystemPowerOnOff () {
      const inf = JSON.stringify({
        delay: 5,
        onTimestamp: this.powerOnTimestemp,
        offTimestamp: this.powerOffTimestemp
      })
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = `command/${this.mac}/systemPowerOnOff`
      this.mqttClient.send(message)
    },
    PublishScan () {
      const inf = JSON.stringify({})
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = 'scan'
      this.mqttClient.send(message)
    }
  }
}
</script>

<style lang="css" scoped>
.ant-select {
  font-size: 20px;
  line-height: 1.5;
}

.select-box {
  width: 240px;
  margin: 0 auto;
}

.card-1,
.card-2,
.card-3 {
  background: linear-gradient(rgba(58, 57, 57, 0.6), rgba(57, 56, 56, 0.5)),
    url(https://images.pexels.com/photos/589840/pexels-photo-589840.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260) center no-repeat / cover;
  box-shadow: 5px 8px 50px #555;
  max-width: 400px;
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
}

.text-wrapper {
  display: inline-flex;
  align-items: center;
  margin-left: 5px; /* 根据需要调整间距 */
}

a-button {
  display: inline-flex;
  align-items: center;
}
</style>
